import {PayloadAction} from '@reduxjs/toolkit';
//types
import {IOrganizationNotificationSettingReducer, IUserOrganizationSettingData, IVipPhoneData} from '../../utils/types';

export const pendingOperation = (state: IOrganizationNotificationSettingReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IOrganizationNotificationSettingReducer) => {
	state.isLoading = false;
};

export const getVipPhoneNumbers = (
	state: IOrganizationNotificationSettingReducer,
	{payload}: PayloadAction<IVipPhoneData[]>
) => {
	state.organizationVipPhones = payload;
	state.isLoading = false;
};

export const addVipPhoneNumber = (
	state: IOrganizationNotificationSettingReducer,
	{payload}: PayloadAction<IVipPhoneData>
) => {
	state.organizationVipPhones.push(payload);
	state.isLoading = false;
};

export const deleteVipPhoneNumber = (state: IOrganizationNotificationSettingReducer) => {
	state.isLoading = false;
};

export const getNotificationSetting = (
	state: IOrganizationNotificationSettingReducer,
	{payload}: PayloadAction<IUserOrganizationSettingData>
) => {
	state.organizationSetting = payload;
	state.isLoading = false;
};

export const updateNotificationSetting = (
	state: IOrganizationNotificationSettingReducer,
	{payload}: PayloadAction<IUserOrganizationSettingData>
) => {
	state.organizationSetting = payload;
	state.isLoading = false;
};
